import { useSelector } from 'react-redux'
import { useAlertPopupsContext } from 'context/AlertPopups'
import { PROJECT_MAX_DURATION } from 'consts'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { translate } from 'utils/translations'
import { transformTextVariables } from 'utils/text-transformation'
import { T } from 'consts/translationKeys'

const PROJECT_MAX_DURATION_IN_MINUTES = (PROJECT_MAX_DURATION / 60).toString()

const useAudioLimitCheck = () => {
  const projectDuration = useSelector(projectDataSelectors.duration)
  const getLineEndTime = useSelector(projectDataSelectors.getLineEndTime)
  const { setAlertPopupsData } = useAlertPopupsContext()

  const isAudioDurationAllowed = (
    newDuration: number,
    options?: {
      checkLineOnly?: boolean
      startTime?: number
      lineIndex?: number
    }
  ) => {
    if (options?.checkLineOnly) {
      const targetLineIndex = options.lineIndex ?? 0
      const lineEndTime = getLineEndTime(targetLineIndex)

      // If line is empty, just check if new audio fits within project limit
      if (lineEndTime === 0) {
        return newDuration <= PROJECT_MAX_DURATION
          ? true
          : showWarningAndReturnFalse()
      }

      // Check if adding at the specified position would exceed project max duration
      const startTime = options.startTime ?? lineEndTime
      return startTime + newDuration <= PROJECT_MAX_DURATION
        ? true
        : showWarningAndReturnFalse()
    }

    // Check against total project duration
    return projectDuration + newDuration <= PROJECT_MAX_DURATION
      ? true
      : showWarningAndReturnFalse()
  }

  const showWarningAndReturnFalse = () => {
    setAlertPopupsData({
      warningPopup: {
        title: transformTextVariables(
          translate(T.PROJECT_DURATION_WARNING_MESSAGE),
          [{ value: PROJECT_MAX_DURATION_IN_MINUTES }]
        ),
        description: transformTextVariables(
          translate(T.PROJECT_BETA_VERSION_DURATION_WARNING_MESSAGE),
          [{ value: PROJECT_MAX_DURATION_IN_MINUTES }]
        ),
        buttons: {
          confirm: { label: translate(T.OK_THANKS_LABEL) }
        }
      }
    })
    return false
  }

  return { isAudioDurationAllowed }
}

export default useAudioLimitCheck
